var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('CallPositionsChart',{attrs:{"chartData":_vm.chart_amount_vs_ratio_cdf,"chartLabels":_vm.chart_amount_vs_ratio_cdf_labels,"yLabel":"Percentage of supply"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }